import { useState } from 'react';
import { faAward, faChevronDown, faChevronUp, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Container, Row } from 'react-bootstrap';
import CertificationInfoPanel from './certificateInformationPanel';
import CertificationsIcon from '../../../../../assets/images/Ic_certificate.png';

const CertificateInfo = ({ certificateDocs }) => {
  const docs = Array.isArray(certificateDocs) ? certificateDocs : [];
  const [showAll, setShowAll] = useState(false);

  const visibleCertificates = showAll ? docs : docs.slice(0, 2);

  return (
    <Container className="pt-2 certification-container">
      <Row>
        <Col>
          <h3 className="candidate-heading">
            Certificates ({docs.length})
            <img src={CertificationsIcon} alt="Certifications" className="profile-work-experience-nav-icon" />
          </h3>
        </Col>
      </Row>
      <Container>
        {visibleCertificates.map((certificate, index) => (
          <CertificationInfoPanel
            key={`certificate-${index}`}
            colorSeed={Math.random()}
            certificate={certificate}
          />
        ))}
      </Container>
      {docs.length > 2 && (
        <Row>
          <Col>
            <a
              className="certifications-view-all"
              onClick={() => setShowAll((prev) => !prev)}
            >
              {showAll ? 'View Less' : 'View All'}
              <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown} />
            </a>
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default CertificateInfo;
